import API from '../utils/api'

const eventsApiBaseUrl = '/api/events';
const contentUrl = eventsApiBaseUrl + '/findbymonth/';


export function findEvents(params) {
  return API.get(contentUrl, {
    params: params
  }).then(response => {
    return response
  })
}